import React, { useState, useContext, useEffect } from "react";
import "./ChangePasswordv2.scss";
import Axios from "axios";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import StateContext from "../../StateContext";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { withTranslation, useTranslation, Trans } from "react-i18next";

import Page from "../Page";
import { handleError } from "../../Functions/getAlert";
import DispatchContext from "../../DispatchContext";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  wrapper: {
    marginTop: "1.5rem",
    position: "relative",
  },
  buttonSuccess: {
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
  },
  fabProgress: {
    color: green[500],
    position: "absolute",
    top: -6,
    left: -6,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

function ChangePasswordv2() {
  // const appState = useContext(StateContext)
  const appDispatch = useContext(DispatchContext)
  const [alertMessage, setAlertMessage] = useState({
    open: false,
    message: "",
    alertSuccess: false,
  });
  const [passwordValues, setPasswordValues] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const appState = useContext(StateContext);
  const [toggleCurrentPassword, setToggleCurrentPassword] = useState(false);
  const { t } = useTranslation();

  const [toggleNewPassword, setToggleNewPassword] = useState(false);
  const [toggleConfirmPassword, setToggleConfirmPassword] = useState(false);
  const buttonClassname = clsx({
    [classes.buttonSuccess]: success,
  });
  const togglePassTypeCurrent = () => {
    setToggleCurrentPassword(!toggleCurrentPassword);
  };
  const togglePassTypeNew = () => {
    setToggleNewPassword(!toggleNewPassword);
  };
  const togglePassTypeConfirm = () => {
    setToggleConfirmPassword(!toggleConfirmPassword);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);
    if(passwordValues.newPassword && passwordValues.confirmPassword !== ""){
      if (passwordValues.newPassword === passwordValues.confirmPassword) {
        try {
          const response = await Axios.post(
            `${process.env.REACT_APP_API_URL}change/password`,
            {
              // id: appState.login.id,
              old_password: passwordValues.currentPassword,
              password: passwordValues.newPassword,
              c_password: passwordValues.confirmPassword,
            },
            {
              headers: {
                Authorization: `Bearer ${appState.token}`,
              },
            }
          );
          // ${process.env.REACT_APP_API_URL}change-password
          setLoading(false);
          setSuccess(true);
          setPasswordValues({
            currentPassword: "",
            newPassword: "",
            confirmPassword: "",
          });
          setAlertMessage({
            open: true,
            message: "Your account password has been changed succesfully!",
            alertSuccess: true,
          });
        } catch (e) {
          handleError(e, appDispatch);
          setPasswordValues({
            currentPassword: "",
            newPassword: "",
            confirmPassword: "",
          });
          setLoading(false);
        }
      } else {
        setAlertMessage({
          open: true,
          message: "Passwords Do Not Match!",
          alertSuccess: false,
        });
        setSuccess(false);
        setLoading(false);
      }
    }else{
      setAlertMessage({
        open: true,
        message: "Please fill required fields.",
        alertSuccess: false,
      });
      setPasswordValues({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
      setLoading(false);
      setSuccess(false);
    }
   
  };
  const updateField = (e) => {
    setPasswordValues({
      ...passwordValues,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    setTimeout(
      () => setAlertMessage({ open: false, message: "", alertSuccess: false }),
      8000
    );
  }, [alertMessage.open]);
  return (
    <Page title="Change Password">
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={alertMessage.open}
        className={alertMessage.alertSuccess ? "success-alert" : "danger-alert"}
      >
        {alertMessage.alertSuccess ? (
          <Alert severity="success">{alertMessage.message}</Alert>
        ) : (
          <Alert severity="error">{alertMessage.message}</Alert>
        )}
      </Snackbar>
      <div id="ChangePasswordv2">
  
        <form action="" onSubmit={handleSubmit}>
          <div className="changePasswordFormv2">
            <div
              className={`${appState.langValue === "ar" ? "changPassformRtlv2" : ""
                } col-md-6 form_col`}
            >
              <TextField
                id="current_password_field"
                name="currentPassword"
                value={passwordValues.currentPassword}
                onChange={updateField}
                type={toggleCurrentPassword ? "text" : "password"}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={togglePassTypeCurrent}
                        onMouseDown={(e) => e.preventDefault()}
                      >
                        {toggleCurrentPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                className="w-100"
                label={t("form.current-pass")}
                InputLabelProps={{
                  shrink: true,
                }}
                variant="filled"
              />
            </div>
            <div
              className={`${appState.langValue === "ar" ? "changPassformRtlv2" : ""
                } col-md-6 form_col`}
            >
              <TextField
                id="new_password_value"
                onChange={updateField}
                name="newPassword"
                value={passwordValues.newPassword}
                type={toggleNewPassword ? "text" : "password"}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={togglePassTypeNew}
                        onMouseDown={(e) => e.preventDefault()}
                      >
                        {toggleNewPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                className="w-100"
                label={t("form.New-pass")}
                InputLabelProps={{
                  shrink: true,
                }}
                variant="filled"
              />
            </div>
            <div
              className={`${appState.langValue === "ar" ? "changPassformRtlv2" : ""
                } col-md-6 form_col`}
            >
              <TextField
                id="confirm_password_value"
                onChange={updateField}
                name="confirmPassword"
                value={passwordValues.confirmPassword}
                type={toggleConfirmPassword ? "text" : "password"}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={togglePassTypeConfirm}
                        onMouseDown={(e) => e.preventDefault()}
                      >
                        {toggleConfirmPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                className="w-100"
                label={t("form.Confirm-new-pass")}
                InputLabelProps={{
                  shrink: true,
                }}
                variant="filled"
              />
            </div>
            <div className="col-md-6 d-flex flex-column align-items-center form_col">
              <Button
                variant="contained"
                className={`${buttonClassname} col-md-3 col-12 bg-primary login_btn`}
                disabled={loading}
                type="submit"
              >
                {loading ? t("form.changing-pass") : t("form.Change-Password")}
              </Button>
              {loading && (
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              )}
            </div>
          </div>
        </form>
      </div>

    </Page>
  );
}

export default withTranslation()(ChangePasswordv2);
